const indexItems = [
  { id: 1, title: '热门电影', icon: 'ri-movie-2-line', count: '8500+', desc: '院线大片、经典回顾、高分精选', color: 'bg-primary-500' },
  { id: 2, title: '热播剧集', icon: 'ri-tv-2-line', count: '6200+', desc: '国产剧、韩剧、日剧、美剧', color: 'bg-accent-500' },
  { id: 3, title: '人气动漫', icon: 'ri-emotion-laugh-line', count: '3800+', desc: '日漫、国漫、剧场版动画', color: 'bg-secondary-500' },
  { id: 4, title: '综艺娱乐', icon: 'ri-mic-2-line', count: '2100+', desc: '热门综艺、脱口秀、选秀', color: 'bg-primary-600' },
  { id: 5, title: '纪录片', icon: 'ri-earth-line', count: '1500+', desc: '自然、历史、人文、科技', color: 'bg-accent-600' },
  { id: 6, title: '悬疑推理', icon: 'ri-search-eye-line', count: '1200+', desc: '烧脑大片、侦探剧、犯罪片', color: 'bg-secondary-600' },
  { id: 7, title: '少儿专区', icon: 'ri-bear-smile-line', count: '900+', desc: '动画片、教育节目、亲子内容', color: 'bg-primary-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            全站索引
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全方位覆盖，总有一个频道适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-4 md:p-5 text-center cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 ${item.color} rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xl md:text-2xl font-heading font-bold text-primary-500 mb-1 whitespace-nowrap">{item.count}</p>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#media"
            onClick={(e) => { e.preventDefault(); document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            <i className="ri-play-circle-line"></i>
            开始浏览
          </a>
        </div>
      </div>
    </section>
  );
}